import PropTypes from 'prop-types';
import React from 'react';
import uniqueId from 'lodash/uniqueId';
import cx from 'classnames';

const Switch = ({ onChange, disabled, checked, label, className }) => {
  const id = uniqueId('switch-');
  const rootClassName = cx('c-switch u-inline-block u-align-middle', className);

  return (
    <div className={rootClassName}>
      <input
        id={id}
        className="c-switch__toggle"
        type="checkbox"
        onChange={e => onChange(e.target.checked)}
        disabled={disabled}
        checked={checked}
      />
      <label className="c-switch__label" htmlFor={id} />
      { label && <div className="c-switch__text">{label}</div> }
    </div>
  );
};
Switch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
};
Switch.defaultProps = {
  checked: false,
  disabled: false,
  onChange: () => null,
  label: null,
  className: '',
};

export default Switch;
